/**
 * Regras de visibilidade dos botões da linha — extraídas da view para reuso e testes.
 * `perm` deve seguir o mesmo contrato de getPermissionFw (nome da permissão → boolean).
 */

const PARAM_TIPO_PROPRIETARIO_OUTROS = 2;

function isTransportadorTipoProprietarioOutros(shipment) {
  if (!shipment || !shipment.pessoa || !shipment.pessoa.paramTipoProprietario) {
    return false;
  }

  return Number(shipment.pessoa.paramTipoProprietario.cd) === PARAM_TIPO_PROPRIETARIO_OUTROS;
}

export function showDocumentIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    shipment.statusIntegracoes.shouldReintegrateDocument
  );
}

export function showCiotIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    !isTransportadorTipoProprietarioOutros(shipment) &&
    shipment.statusExpedicaoDespesa == 3 &&
    shipment.statusProcessoExpedicao.valor == 2 &&
    shipment.statusIntegracoes.statusIroute.valor == 3 &&
    shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 1 &&
    shipment.statusIntegracoes.statusTargetCiot &&
    shipment.statusIntegracoes.statusTargetCiot.status.valor == 2
  );
}

export function showEstornaCalculoButton(perm, shipment) {
  /* Mesma precedência && / || do método original na view */
  return (
    (perm("expedicao.calculo.estornar") &&
      shipment.statusProcessoExpedicao.valor != 1 &&
      (shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor ==
        1 ||
        shipment.statusExpedicaoDespesa == 3) &&
      (shipment.cargaCiot == null &&
        (shipment.status.valor == 3 || shipment.status.valor == 6))) ||
    (shipment.cargaCiot != null &&
      shipment.cargaCiot.statusCiot == 2 &&
      (shipment.status.valor == 3 || shipment.status.valor == 6))
  );
}

export function showExpanseIntegrationButton(
  perm,
  permiteGerarDespesa,
  shipment
) {
  return (
    perm("expedicao.store") &&
    permiteGerarDespesa &&
    ((!shipment.statusIntegracoes.ishybridModule &&
      shipment.statusProcessoExpedicao.valor != 1 &&
      shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor == 2 &&
      shipment.statusIntegracoes.statusIroute.valor == 3 &&
      shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 1) ||
      shipment.statusIntegracoes.shouldReintegrateExpanse)
  );
}

export function showTargetIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    shipment.statusProcessoExpedicao.valor != 1 &&
    ((shipment.statusIntegracoes.statusIroute.valor == 3 &&
      shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 2) ||
      shipment.statusIntegracoes.shouldReintegrateTarget)
  );
}

export function showEndorsementIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    ((shipment.statusProcessoExpedicao.valor != 1 &&
      shipment.statusIntegracoes.statusGeralAverbacao == 2 &&
      shipment.retira != 1) ||
      shipment.statusIntegracoes.shouldReintegrateEndorsement)
  );
}

export function showItrackIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    (shipment.status.valor == 3 ||
      shipment.statusIntegracoes.shouldReintegrateItrack)
  );
}

export function showRoutingIntegrationButton(perm, shipment) {
  return (
    perm("expedicao.store") &&
    ((shipment.statusProcessoExpedicao.valor != 1 &&
      shipment.statusIntegracoes.statusGeralAverbacao == 1 &&
      shipment.statusIntegracoes.statusIroute.valor != 3) ||
      shipment.statusIntegracoes.shouldReintegrateRouting)
  );
}

export function getManifestosDaCarga(shipment) {
  if (Array.isArray(shipment.manifestos) && shipment.manifestos.length) {
    return shipment.manifestos;
  }
  return shipment.manifesto ? [shipment.manifesto] : [];
}

export function hasManifestoImprimivel(shipment) {
  const manifestos = getManifestosDaCarga(shipment);
  if (!manifestos.length) {
    return false;
  }
  return manifestos.every((m) => m && m.status === 6);
}

export function getManifestoIdsParaImpressao(shipment) {
  if (!hasManifestoImprimivel(shipment)) {
    return [];
  }
  return getManifestosDaCarga(shipment).map((m) => m.manifestoId);
}
